/* eslint-disable no-console */
import {ReloadOutlined} from '@ant-design/icons';
import {Button, Flex, Select} from 'antd';
import React, {useEffect, useState} from 'react';

import Loader from '../../../../components/Loader/Loader';
import activityPerformance from '../../../../services/modules/DASHBOARD/activityPerformance';
import benchmark from '../../../../services/modules/DASHBOARD/benchmark';
import emissionCalculation from '../../../../services/modules/DASHBOARD/emissionCalculation';
// import listOfActivity from '../../../../services/modules/DASHBOARD/listOfActivity';
import listOfActivity from '../../../../services/modules/DASHBOARD/listOfActivity';
import reduction from '../../../../services/modules/DASHBOARD/reduction';
import reductionTimeline from '../../../../services/modules/DASHBOARD/reductionTimeline';
import country from '../../../../services/modules/JSON/country';
import statesJSON from '../../../../services/modules/JSON/statesJSON';
import usePlatformStore from '../../../../store/platformStore/platformStore';
import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {shouldBlockFree} from '../../../../utils/SubscriptionHelper';

import {benchmarkDataIds} from './constants/commonConstants';
import ListOfActivities from './ListOfActivities';

const Metrics: React.FC = () => {
  const [isMetricsLoading, setIsMetricsLoading] = useState(true);
  const [isReductionLoading, setIsReductionLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(yearSelect()[0].value);
  const [activityData, setActivityData] = useState<any>([]);
  const [listData, setListData] = useState<any>([]);
  const [refresing, setRefresing] = useState<boolean>();
  const [refreshPage, setRefreshPage] = useState(false);
  const [industryBenchmarksData, setIndustryBenchmarksData] = useState<any>({});
  const isLoading = isMetricsLoading || isReductionLoading;

  useEffect(() => {
    if (selectedYear) {
      setIsMetricsLoading(true);
      Promise.all([
        activityPerformance(selectedYear),
        listOfActivity(selectedYear),
        country(),
        statesJSON(),
        benchmark(benchmarkDataIds.emissionsScopeWise, selectedYear),
        benchmark(benchmarkDataIds.intensityWise, selectedYear),
        benchmark(benchmarkDataIds.consumptionWise, selectedYear)
      ])
        .then(
          ([
            activity,
            list,
            _countryRes,
            _statesRes,
            emissionsRes,
            intensityRes,
            consumptionRes
          ]) => {
            setActivityData(activity);
            setListData(list?.data);
            setIndustryBenchmarksData((prev: any) => ({
              ...prev,
              emissionsData: emissionsRes?.data,
              intensityData: intensityRes?.data,
              consumptionData: consumptionRes?.data
            }));
          }
        )
        .catch(() => {
          setIndustryBenchmarksData((prev: any) => ({
            ...prev,
            emissionsData: undefined,
            intensityData: undefined,
            consumptionData: undefined
          }));
        })
        .finally(() => {
          setIsMetricsLoading(false);
        });
    }
  }, [selectedYear, refreshPage]);

  useEffect(() => {
    setIsReductionLoading(true);
    Promise.all([reduction(), reductionTimeline()])
      .then(([reductionRes, reductionTimelineRes]) => {
        setIndustryBenchmarksData((prev: any) => ({
          ...prev,
          reductionData: reductionRes?.data,
          reductionTimelineData: reductionTimelineRes?.data
        }));
      })
      .catch(() => {
        setIndustryBenchmarksData((prev: any) => ({
          ...prev,
          reductionData: undefined,
          reductionTimelineData: undefined
        }));
      })
      .finally(() => {
        setIsReductionLoading(false);
      });
  }, [refreshPage]);

  const handleRefreshClick = () => {
    setRefresing(true);
    Promise.all([emissionCalculation(selectedYear)])
      .then(() => {
        setRefreshPage(!refreshPage);
      })
      .catch(() => {})
      .finally(() => {
        setRefresing(false);
      });
  };

  return (
    <Flex className="metricsMainContainer">
      <Flex justify="space-between" align="center" style={{width: '100%'}}>
        <div style={{marginBottom: '10px'}}>
          <Select
            placeholder={'Select Year'}
            defaultValue={selectedYear}
            className="LAselect"
            onChange={(value) => {
              setSelectedYear(value);
            }}
            disabled={isLoading || refresing}
            // defaultActiveFirstOption={true}
            options={yearSelect()}
          />
        </div>
        {shouldBlockFree() ? (
          <Button
            type="default"
            icon={<ReloadOutlined />}
            style={{marginBottom: '10px'}}
            title="Reflecting data from Carbon Accounting"
            loading={refresing}
            onClick={() => {
              usePlatformStore.getState().setOpenOnFreeTrialMessageModel(true);
            }}
          ></Button>
        ) : (
          <Button
            type="default"
            icon={<ReloadOutlined />}
            style={{marginBottom: '10px'}}
            title="Reflecting data from Carbon Accounting"
            loading={refresing}
            onClick={() => {
              handleRefreshClick();
            }}
          ></Button>
        )}
      </Flex>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <ListOfActivities
            data={listData}
            industryBenchmarksData={industryBenchmarksData}
            selectedYear={selectedYear}
            activityData={activityData}
          />
        </div>
      )}
    </Flex>
  );
};

export default Metrics;
